import React, {PureComponent} from 'react';
import {
  Col,
  Row,
  Grid,
  Form,
  FormGroup,
  FormControl,
  ControlLabel,
  Button,
} from 'react-bootstrap';
import './ContactPage.css';
import request from 'superagent';

class ContactPage extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      name: '',
      email: '',
      message: '',
      disabled: true,
    };
  }

  render() {
    const evaluateAndEnableSend = () => {
      if (this.state.name.length > 0 &&
          this.state.email.length > 0 &&
          this.state.message.length > 0) {
        this.setState({ disabled: false });
      } else {
        this.setState({ disabled: true });
      }
    };

    return (
      <div className="ContactPage">
        <Grid>
          <Row>
            <Col sm={8} smOffset={2}>
              <h2>Contact Susan</h2>
              <p>To contact Susan fill out the following form and click on the send button.</p>
              <br />
              <br />
              <Form horizontal>
                <FormGroup controlId="formHorizontalEmail">
                  <Col componentClass={ControlLabel} sm={4}>
                    Name
                  </Col>
                  <Col sm={8}>
                    <FormControl
                      type="text"
                      placeholder="Name"
                      value={this.state.name}
                      onChange={(ev) => {
                        this.setState({ name: ev.target.value }, evaluateAndEnableSend);
                      }}
                    />
                  </Col>
                </FormGroup>
                <FormGroup controlId="formHorizontalEmail">
                  <Col componentClass={ControlLabel} sm={4}>
                    Email
                  </Col>
                  <Col sm={8}>
                    <FormControl
                      type="email"
                      placeholder="Email"
                      value={this.state.email}
                      onChange={(ev) => {
                        this.setState({ email: ev.target.value }, evaluateAndEnableSend);
                      }}
                    />
                  </Col>
                </FormGroup>

                <FormGroup controlId="formControlsTextarea">
                  <Col componentClass={ControlLabel} sm={4}>
                    Message
                  </Col>
                  <Col sm={8}>
                    <FormControl
                      componentClass="textarea"
                      placeholder="Your message...."
                      value={this.state.message}
                      onChange={(ev) => {
                        this.setState({ message: ev.target.value }, evaluateAndEnableSend);
                      }}
                    />
                  </Col>
                </FormGroup>

                <FormGroup>
                  <Col smOffset={4} sm={8}>
                    <Button
                      disabled={this.state.disabled}
                      onClick={() => {
                        request
                          .post('/hooks/catch/272412/5vk6ra/')
                          .send(this.state)
                          .set('Accept', 'application/json')
                          .end(function(err, res){
                            if (err || !res.ok) {
                              alert('Error sending message. Please try again later.');
                            } else {
                              alert('Your message has been delivered.');
                            }
                          });
                      }}
                    >
                      Send Message
                    </Button>
                    &nbsp;&nbsp;
                    <Button
                      onClick={() => {
                        window.location = 'http://susanpayneobrien.com';
                      }}
                    >
                      Cancel
                    </Button>
                  </Col>
                </FormGroup>
              </Form>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default ContactPage;



// WEBPACK FOOTER //
// ./src/containers/ContactPage.jsx